import { RequestSorting } from "../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { SortingOption } from "./types";

export const commonSortingOptions: SortingOption[] = [
  {
    requestSorting: { property: "shippingTime" },
    title: "Podle rychlosti doručení",
  },
  {
    requestSorting: { property: "averageRating" },
    title: "Podle hodnocení",
  },
  {
    requestSorting: { order: "asc", property: "price" },
    title: "Od nejlevnějšího",
  },
  {
    requestSorting: { order: "desc", property: "price" },
    title: "Od nejdražšího",
  },
];

export const defaultSorting: RequestSorting = { property: "shippingTime" };
